import { NgModule } from '@angular/core';
import { CommonModule } from '@nano/common';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzListModule } from 'ng-zorro-antd/list';

import { MessageThreadListComponent } from './message-thread-list.component';
@NgModule({
  imports: [CommonModule, NzBadgeModule, NzListModule],
  declarations: [MessageThreadListComponent],
  exports: [MessageThreadListComponent]
})
export class MessageThreadListModule {}
